import { Box, TextField, withStyles } from '@material-ui/core';
import { fonts } from '../utilities/styles/index';
export const StyledBox = withStyles((theme) => ({
  root: {
    borderRadius: `${theme.spacing(1)}px`,
    padding: `${theme.spacing(0)}px`,
    maxWidth: `${theme.spacing(60)}px`,
    margin: `${theme.spacing(1.2)}px`,
    width: `85%`,
    ['@media (max-width:780px)']: {
      width:' 75%',
      overflow: 'hidden'
    },
  },
}))(Box);
export const StyledDateField = withStyles((theme) => ({
  root: {
    display: (props) => (props.required ? 'flex' : 'none'),
    alignItems: 'center',
    border: `0.5px solid ${theme.palette.secondary.light}`,
    borderRadius: '2px',
    background: theme.palette.secondary.lighter,
    height: '60px',
    paddingLeft: (props) => (props.fullWidth ? '12px' : '0px'),
    height: '60px',
    "& label": {
       paddingLeft: (props) => (props.fullWidth ? '20px' :  '0px'),
    },
    '& .MuiInputLabel-root': {
      fontSize: 8,
      fontWeight: 400,
      color: theme.palette.secondary.darker,
      fontFamily: fonts.rubik.value,
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2),
      marginTop: '-14px',
      transition: 'none',
    },
    '.MuiInputLabel-animated': {
      transition: 'none',
    },
    '& .MuiInputLabel-shrink': {
      fontSize: 10,
      fontWeight: 400,
      marginTop: theme.spacing(1),
      color: theme.palette.secondary.darker,
      fontFamily: fonts.rubik.value,
    },
    '& .MuiInput-input': {
      fontSize: 14,
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2),
      marginBottom: theme.spacing(0.5),
      marginTop: theme.spacing(0.5),
      fontFamily: fonts.lexend.value,
    },
    '& .MuiInput-underline:hover::before': {
      display: 'none',
    },
    '& .MuiInput-underline::before': {
      display: 'none',
    },
    '& .MuiInput-underline::after': {
      display: 'none',
    },
  },
}))(TextField);

    export const StyledTextField = withStyles((theme) => ({
  root: {
    display: (props) => (props.required ? 'flex' : 'none'),
    alignItems: 'center',
    border: `0.5px solid rgb(196 196 196);`,
    boxShadow: 'rgb(0 0 0 / 9%) 0px 0px 15.4px 0.6px',
    borderRadius: '8px',
    background: '#fff' ,
    paddingLeft: (props) => (props.fullWidth ? '12px' : '0px'),
    height: '60px',
    "& label": {
       paddingLeft: (props) => (props.fullWidth ? '20px' :  '0px'),
    },
    '& .MuiInputLabel-root': {
      fontSize: 14,
      fontFamily: fonts.lexend.value,
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2),
      marginBottom: theme.spacing(0.5),
    },
    '& .MuiInputLabel-shrink': {
      fontSize: 10,
      fontWeight: 400,
      marginTop: theme.spacing(1),
      color: theme.palette.secondary.darker,
      fontFamily: fonts.rubik.value,
    },
    '& .MuiInput-input': {
      fontSize: 14,
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2),
      marginBottom: theme.spacing(0.5),
      marginTop: theme.spacing(0.5),
      fontFamily: fonts.lexend.value,
      color: (props) =>
        props.inputKey === 'dob' && props.error && theme.palette.error.main,
    },
    '& .MuiInput-underline:hover::before': {
      display: 'none',
    },
    '& .MuiInput-underline::before': {
      display: 'none',
    },
    '& .MuiInput-underline::after': {
      display: 'none',
    },
  },
}))(TextField);
